// resources/js/admin/components/shared/locales/LocalesList.tsx

import { Locale } from "../../../types/features/Locale";
import TableList, { SelectAction } from "../../ui/TableList";
import LocaleRow from "./LocaleRow";

interface LocalesListProps {
    locales: Locale[];
    onAction: (locale: Locale) => void;
    onSelectLocales?: (selectedLocales: Locale[]) => void;
    selectable?: boolean;
    selectActions?: SelectAction[];
    loading?: boolean;
    emptyMessage?: string;
}

export default function LocalesList({
    locales,
    onAction,
    onSelectLocales,
    selectable = false,
    selectActions,
    loading = false,
    emptyMessage = "Aucune langue trouvée",
}: LocalesListProps) {
    const columns = [
        { header: "Langue", className: "w-1/4" },
        { header: "Code", className: "w-1/6" },
        { header: "Direction", className: "hidden sm:table-cell w-1/6" },
        { header: "Statut", className: "hidden md:table-cell w-1/6" },
        { header: "Fallback", className: "hidden lg:table-cell w-1/6" },
        { header: "Créée le", className: "hidden xl:table-cell w-1/6" },
    ];

    if (loading) {
        return (
            <div className="flex justify-center items-center py-12">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
            </div>
        );
    }

    return (
        <TableList
            items={locales}
            columns={columns}
            getId={(locale) => locale.id}
            onAction={onAction}
            onSelectItems={onSelectLocales}
            selectable={selectable}
            emptyMessage={emptyMessage}
            actionColumn={true}
            selectActions={selectActions}
            renderRow={(locale, isSelected, onSelect) => (
                <LocaleRow
                    key={locale.id}
                    locale={locale}
                    onAction={onAction}
                    onSelect={onSelect}
                    isSelected={isSelected}
                    selectable={selectable}
                />
            )}
        />
    );
}